import { SEOHead } from '../components/SEOHead';
import { AppNavigationBar } from '../components/AppNavigationBar';
import { Image as ImageIcon } from 'lucide-react';

export default function AppGallery() {
  return (
    <div className="relative w-full h-screen bg-[var(--color-white)]">
      <SEOHead title="Galerie – pixcapture.app" description="Ihre bearbeiteten Fotos" path="/app/gallery" />
      
      <div className="flex flex-col items-center justify-center h-full px-8">
        <ImageIcon className="h-16 w-16 text-[var(--color-accent)] mb-4" />
        <h1 className="text-[24px] mb-2">Ihre Galerie</h1>
        <p className="text-[var(--color-grey)] text-center">
          Hier erscheinen Ihre bearbeiteten Fotos
        </p>
      </div>

      <AppNavigationBar activeRoute="/app/gallery" />
    </div>
  );
}
